import { assertNever } from '@/utils/assertNever'
import { JSONStringifyRich } from '@/utils/object'
import { Objective } from './types'

export function stringifyObjectivesDeep(objectives: Objective[]): string {
  return JSONStringifyRich(objectives)
}

export function stringifyObjectivesToStableActions(objectives: Objective[]): string {
  return JSON.stringify(
    objectives.map((objective) => {
      switch (objective.type) {
        case 'deposit':
        case 'borrow':
          return [objective.type, objective.token.address, objective.value]
        case 'withdraw':
          return [objective.type, objective.reserve.token.address, objective.value]
        case 'repay':
          return [
            objective.type,
            objective.reserve.token.address,
            objective.value,
            objective.useAToken,
            objective.initialToken.address,
          ]
        case 'setUseAsCollateral':
          return [objective.type, objective.useAsCollateral]
        case 'setUserEMode':
          return [objective.type, objective.eModeCategoryId]
        case 'claimMarketRewards':
          return [objective.type, objective.token.address, objective.assets]
        case 'bridgeToHyperEVM':
        case 'bridgeToHyperCore':
          return [objective.type, objective.from.token.symbol, objective.amount, objective.tokenId || '']
        case 'isolatedWithdraw':
          return [objective.type, objective.token.address, objective.value, objective.pairAddress]
        case 'isolatedLendWithdraw':
          return [objective.type, objective.token.address, objective.value, objective.pairAddress]
        case 'isolatedLendDeposit':
          return [objective.type, objective.token.address, objective.value]
        case 'isolatedDeposit':
          return [objective.type, objective.token.address, objective.value]
        case 'isolatedBorrow':
          return [objective.type, objective.token.address, objective.value]
        case 'isolatedRepay':
          return [objective.type, objective.token.address, objective.value, objective.shares, objective.pairAddress]
        case 'vaultDeposit':
          return [
            objective.type,
            objective.vaultType,
            objective.token.address,
            objective.value,
            objective.tokenOutAddress,
            objective.rateInQuote,
            objective.receiver,
            objective.enableAsCollateral,
          ]
        case 'vaultWithdraw':
          // Note: deadline is intentionally excluded from the key because it uses Date.now()
          // and would cause ActionsContainer to remount (losing transaction state) if objectives
          // are recreated due to dependency changes like shareBalance updates
          return [
            objective.type,
            objective.vaultType,
            objective.token.address,
            objective.value,
            objective.atomicQueueVaultAddress,
            objective.rateInQuoteSafeWithFee,
          ]
        case 'wrap':
          return [objective.type, objective.token.address, objective.value]
        case 'permit2Sign':
          return [objective.type, objective.token.address, String(objective.amount), objective.spender]
        default:
          assertNever(objective)
      }
    }),
  )
}
